module.exports = __webpack_public_path__ + "static/img/45-3.9a00cee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/45-3.jpg
// module id = 34Za
// module chunks = 0